
import { computed, defineComponent, PropType } from 'vue'
import { Entry, RequestHandler } from '@Protium/vue-ozone-utils'
// import { useStore } from 'vuex'
// import { OperationalData } from '@/pages/Dashboard/components/interfaces/index'
// import { generateTrackingUrl } from '@/utils/shipment'

interface DocumentViewerState {
  currentDialog: string,
  fulfillment: any,
  document: {
    labels: Array<any> | null,
    slip: Array<any> | null
  },
  dialog: {
    labels: boolean,
    slip: boolean
  }
}

export const formatObjectKey = (key: string) => {
  return key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1').trim().toLowerCase()
}

export default defineComponent({
  name: 'OrderErrorDetails',
  props: {
    meta: {
      type: Object as PropType<Record<string, string | string[]> | undefined>,
      required: true
    },
    order: {
      type: String,
      required: true
    },
    request: {
      type: Object as PropType<RequestHandler<Entry>>
    }
  },
  setup (props) {
    // const $store = useStore()
    // const $request = props.request || $store.getters['Services/Directr']
    // const requestHandler = props.request || $store.getters['Services/Directr']


    function parseError (error: Record<string, any> | undefined) {
      let str = ''
      let data:any = error
      do {
        if (!data?.error && !data?.message && !data?.payload && !data?.failed && typeof data !== 'string' && !Array.isArray(data)) data = undefined

        if (data?.message) str += `${data.message}. `
        if (data?.error) data = data.error
        if (data?.message) str += `${data.message}. `
        if (data?.payload) data = data.payload
        if (data?.message) str += `${data.message}. `
        if (data?.failed) data = data.failed
        if (data?.message) str += `${data.message}. `
        if (typeof data === 'string') {
          str += `${data}. `
          data = undefined
        }
        if (Array.isArray(data)) {
          data.forEach(d => { typeof d !== 'object' ? str += `${d}` : null })
          data = undefined
        }
      } while (data)

      return str.trim()
    }

    return {
      parsedError: computed(() => parseError(props.meta)),
      formatObjectKey
    }
  }
})
